import "@shared/assets/styles/popup_common.custom.css"

import React from "react"

import { ScheduleProvider } from "@shared/contexts"
import { useCriteo, useCRM } from "@shared/hooks"
import { useValidation } from "@shared/hooks/useValidation"

import { Counsels } from "counsels/components"

function CounselsPage() {
  useCriteo()
  useCRM()

  useValidation()

  return <Counsels />
}

export default () => (
  <ScheduleProvider isDetect={false}>
    <CounselsPage />
  </ScheduleProvider>
)
